import { render, staticRenderFns } from "./Aochen_peizhi.vue?vue&type=template&id=eba9bc4e&scoped=true"
import script from "./Aochen_peizhi.vue?vue&type=script&lang=js"
export * from "./Aochen_peizhi.vue?vue&type=script&lang=js"
import style0 from "./Aochen_peizhi.vue?vue&type=style&index=0&id=eba9bc4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba9bc4e",
  null
  
)

export default component.exports